import { IconProps } from "../../utils/global-types/global-types";

const SyncFailedIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 9 9"
    className={className ? className : "w-[9px] h-[9px]"}
    {...rest}
  >
    <rect width="9" height="9" rx="4.5" fill="currentColor" />
    <path
      fill="var(--color-fixed-white-light-and-dark-mode)"
      d="M4.77523 4.36249L6.02734 3.11037C6.14128 2.99644 6.14128 2.81187 6.02734 2.69794C5.91341 2.584 5.72884 2.584 5.61491 2.69794L4.36279 3.95005L3.11068 2.69794C2.99674 2.584 2.81217 2.584 2.69824 2.69794C2.58431 2.81187 2.58431 2.99644 2.69824 3.11037L3.95036 4.36249L2.69824 5.6146C2.58431 5.72854 2.58431 5.91311 2.69824 6.02704C2.75521 6.084 2.82983 6.11249 2.90446 6.11249C2.97909 6.11249 3.05371 6.084 3.11068 6.02704L4.36279 4.77492L5.61491 6.02704C5.67188 6.084 5.7465 6.11249 5.82113 6.11249C5.89575 6.11249 5.97038 6.084 6.02734 6.02704C6.14128 5.91311 6.14128 5.72854 6.02734 5.6146L4.77523 4.36249Z"
    ></path>
  </svg>
);

export default SyncFailedIcon;
